import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { ArrowLeft } from "lucide-react";

export const LEGAL_DOC_VERSION = "1.0";

const DOCS = {
  termini: {
    title: "Termini e Condizioni",
    body: [
      "La presente piattaforma 'Fuma c'anduma' mette in contatto clienti, attività commerciali e rider per il servizio di consegna a domicilio nell'area del Canavese e di Torino.",
      "Utilizzando la piattaforma, l'attività commerciale accetta di fornire dati veritieri e aggiornati, di rispettare le normative vigenti in materia di somministrazione e vendita, e di gestire correttamente gli ordini ricevuti.",
      "La piattaforma applica una commissione sugli ordini e un costo di servizio, come indicato nel pannello di gestione. Le tariffe di consegna sono calcolate automaticamente in base alla distanza.",
      "La piattaforma si riserva il diritto di sospendere o rimuovere le attività che violino i presenti termini o che ricevano segnalazioni ripetute da parte dei clienti.",
    ],
  },
  privacy: {
    title: "Informativa Privacy (GDPR)",
    body: [
      "Ai sensi del Regolamento (UE) 2016/679 (GDPR), i dati personali forniti in fase di registrazione (dati anagrafici, di contatto, fiscali e relativi all'attività) sono trattati dal titolare del trattamento al solo fine di erogare il servizio.",
      "I dati sono conservati su infrastruttura Firebase/Google Cloud (Firestore e Firebase Authentication) con misure di sicurezza adeguate. Non vengono ceduti a terzi se non per finalità strettamente connesse all'erogazione del servizio (es. rider per la consegna).",
      "In fase di accettazione vengono registrati data, ora, versione del documento e, se disponibile, l'indirizzo IP, ai fini della prova del consenso.",
      "L'interessato può in ogni momento esercitare i diritti di accesso, rettifica, cancellazione, limitazione e portabilità dei dati contattando l'assistenza.",
    ],
  },
  contratto: {
    title: "Contratto di collaborazione",
    body: [
      "Il presente contratto regola il rapporto di collaborazione commerciale tra l'attività e la piattaforma 'Fuma c'anduma'.",
      "L'attività autorizza la piattaforma a pubblicare il proprio catalogo, ricevere e gestire ordini per suo conto e incassare i pagamenti tramite il gestore di pagamento integrato (Stripe), con successivo riversamento al netto delle commissioni pattuite.",
      "L'attività è responsabile della qualità e conformità dei prodotti offerti, del rispetto degli orari dichiarati e della corretta gestione degli ordini.",
      "Il contratto si intende accettato al momento dell'invio della candidatura ed è efficace dall'approvazione da parte della piattaforma. Ciascuna parte può recedere con preavviso, fatte salve le obbligazioni in corso.",
    ],
  },
};

export default function Legal() {
  const { doc } = useParams();
  const navigate = useNavigate();
  const d = DOCS[doc] || DOCS.termini;
  return (
    <div className="min-h-screen bg-[#0A0A0C] text-white grain">
      <div className="max-w-3xl mx-auto px-6 py-10">
        <Button variant="ghost" data-testid="legal-back" onClick={() => navigate(-1)} className="mb-6 text-zinc-400"><ArrowLeft className="h-4 w-4 mr-1" /> Indietro</Button>
        <div className="text-[#00E676] font-display font-black text-2xl mb-1">Fuma c'anduma</div>
        <h1 data-testid="legal-title" className="text-3xl font-bold mb-1">{d.title}</h1>
        <div className="text-xs text-zinc-500 mb-6">Versione {LEGAL_DOC_VERSION}</div>
        <div className="space-y-4 text-zinc-300 leading-relaxed">
          {d.body.map((p, i) => <p key={i}>{p}</p>)}
        </div>
      </div>
    </div>
  );
}
